/*
 * Instant product search for collection pages.
 *
 * Filters the already-rendered product cards by title as the customer types —
 * no page reload. Because the theme's filters/sort re-render the product grid
 * via the Section Rendering API, a MutationObserver re-applies the active query
 * whenever the grid is replaced (e.g. after selecting a Continent filter).
 */
(function () {
  // Fold Serbian Latin diacritics so accented and plain letters match each other:
  // č/ć → c, š → s, ž → z, đ → d. This lets "ceska" find "Češka", "svicarska"
  // find "Švicarska", and vice versa. NFD splits most accented letters into a base
  // letter + a combining mark we then strip; đ has no such decomposition, so it is
  // mapped explicitly.
  function foldDiacritics(str) {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd');
  }

  function initInlineSearch(root) {
    var input = root.querySelector('.collection-inline-search__input');
    var status = root.querySelector('[data-collection-inline-search-status]');
    var gridContainer = document.getElementById('ProductGridContainer');

    if (!input || !gridContainer) return;

    // Localized status templates, rendered from the theme's locale files.
    // Tokens %count% / %terms% are filled in per keystroke.
    var tplNoResults = root.getAttribute('data-i18n-no-results') || '';
    var tplResultsOne = root.getAttribute('data-i18n-results-one') || '';
    var tplResultsOther = root.getAttribute('data-i18n-results-other') || '';

    function statusText(matches, terms) {
      var template;
      if (matches === 0) {
        template = tplNoResults;
      } else if (matches === 1) {
        template = tplResultsOne;
      } else {
        template = tplResultsOther;
      }
      return template.split('%count%').join(matches).split('%terms%').join(terms);
    }

    function applyFilter() {
      var terms = input.value.trim();
      var query = foldDiacritics(terms);
      var grid = document.getElementById('product-grid');
      var items = grid ? grid.querySelectorAll('.grid__item') : [];
      var matches = 0;

      items.forEach(function (item) {
        var title = foldDiacritics(item.getAttribute('data-title') || '');
        var isMatch = query === '' || title.indexOf(query) !== -1;
        item.classList.toggle('is-search-hidden', !isMatch);
        if (isMatch) matches += 1;
      });

      if (!status) return;
      status.textContent = query === '' ? '' : statusText(matches, terms);
    }

    var debounceTimer;
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(applyFilter, 100);
    });

    // Re-apply the current query after the grid is re-rendered by filters/sort.
    var observer = new MutationObserver(function () {
      if (input.value.trim() !== '') applyFilter();
    });
    observer.observe(gridContainer, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('[data-collection-inline-search]').forEach(initInlineSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
